import { ElMessage as Message } from 'element-plus'

let messageInstance = []

// 包装参数，如果参数是字符串，则设置为 message
const formatOptions = (opts) => {
  if (typeof opts === 'string') {
    return { message: opts, type: 'info' }
  }
  return opts
}

// 重置elmessage
const ElMessage = (options) => {
  messageInstance.forEach((message) => {
    message.close()
  })
  messageInstance = []
  let msgInstance = Message(options)
  messageInstance.push(msgInstance)
  return msgInstance
}

Object.keys(Message).forEach((key) => {
  if (['success', 'warning', 'info', 'error'].includes(key)) {
    // 4 个 type 方法需要额外包装
    ElMessage[key] = function (opts) {
      opts = formatOptions(opts)
      const type = key
      ElMessage({ ...opts, type })
    }
  } else {
    ElMessage[key] = Message[key]
  }
})

export default ElMessage
